export default {
  // Page title
  'smsReport.title': 'Reporte SMS',
  'smsReport.subtitle': 'Estadísticas de envío SMS y reporte de análisis',

  // Form fields
  'smsReport.form.timeRange': 'Rango de Tiempo',
  'smsReport.form.timeRangeRequired': 'Por favor, selecciona rango de tiempo',
  'smsReport.form.startDate': 'Fecha de Inicio',
  'smsReport.form.endDate': 'Fecha de Fin',
  'smsReport.form.startTime': 'Hora de Inicio',
  'smsReport.form.startTimeRequired': 'Por favor, selecciona hora de inicio',
  'smsReport.form.startTimePlaceholder': 'Por favor, selecciona hora de inicio',
  'smsReport.form.endTime': 'Hora de Fin',
  'smsReport.form.endTimeRequired': 'Por favor, selecciona hora de fin',
  'smsReport.form.endTimePlaceholder': 'Por favor, selecciona hora de fin',
  'smsReport.form.taskName': 'Tarea',
  'smsReport.form.taskNamePlaceholder': 'Por favor, ingresa nombre de tarea',
  'smsReport.form.taskType': 'Tipo',
  'smsReport.form.taskTypePlaceholder': 'Por favor, selecciona tipo',
  'smsReport.form.groupBy': 'Agrupar Por',
  'smsReport.form.groupByTooltip': 'Selecciona método de agrupación de datos',

  // Task types
  'smsReport.taskType.all': 'Todos los Tipos',
  'smsReport.taskType.bulk': 'Envío Masivo',
  'smsReport.taskType.automation': 'Automatización',
  'smsReport.taskType.ndc': 'Sin Depósito',
  'smsReport.taskType.inactive': 'Usuarios Inactivos',
  'smsReport.taskType.churn': 'Usuarios Perdidos',
  'smsReport.taskType.vip': 'Tareas VIP',
  'smsReport.taskType.welcome': 'SMS de Bienvenida',
  'smsReport.taskType.restorage': 'Re-depósito después del Primer Depósito',
  'smsReport.taskType.birthday': 'Recordatorio de Cumpleaños',
  'smsReport.taskType.unknown': 'Desconocido',

  // Group options
  'smsReport.groupBy.day': 'Agrupar por Día',
  'smsReport.groupBy.month': 'Agrupar por Mes',
  'smsReport.groupBy.task': 'Agrupar por Tarea',

  // Buttons
  'smsReport.button.search': 'Buscar',
  'smsReport.button.reset': 'Restablecer',
  'smsReport.button.export': 'Exportar Reporte',

  // Statistics cards
  'smsReport.stats.totalSend': 'Total Enviado',
  'smsReport.stats.successSend': 'Exitoso',
  'smsReport.stats.failSend': 'Fallido',
  'smsReport.stats.avgSuccessRate': 'Tasa de Éxito Promedio',
  'smsReport.stats.totalCost': 'Costo Total',

  // Table columns
  'smsReport.table.task': 'Tarea',
  'smsReport.table.type': 'Tipo',
  'smsReport.table.taskName': 'Nombre de Tarea',
  'smsReport.table.taskType': 'Tipo de Tarea',
  'smsReport.table.sendCount': 'Cantidad Enviada',
  'smsReport.table.successCount': 'Cantidad Exitosa',
  'smsReport.table.failCount': 'Cantidad Fallida',
  'smsReport.table.successRate': 'Tasa de Éxito',
  'smsReport.table.cost': 'Costo',
  'smsReport.table.date': 'Fecha',
  'smsReport.table.actions': 'Acciones',
  'smsReport.table.viewLogs': 'Ver Registros',

  // Log modal
  'smsReport.logs.title': 'Registros SMS',
  'smsReport.logs.time': 'Tiempo',
  'smsReport.logs.task': 'Tarea',
  'smsReport.logs.user': 'Usuario',
  'smsReport.logs.phone': 'Teléfono',
  'smsReport.logs.channel': 'Canal',
  'smsReport.logs.status': 'Estado',
  'smsReport.logs.receipt': 'Recepción',
  'smsReport.logs.statusPending': 'Pendiente',
  'smsReport.logs.statusSuccess': 'Exitoso',
  'smsReport.logs.statusFailed': 'Fallido',

  // Messages
  'smsReport.message.selectTimeRange': 'Por favor, selecciona rango de tiempo',
  'smsReport.message.exportSuccess': 'Exportación exitosa',
  'smsReport.message.exportFailed': 'Fallo en la exportación',
  'smsReport.message.exporting': 'Exportando datos...',
  'smsReport.message.queryFailed': 'Consulta fallida',
  'smsReport.message.noData': 'No hay datos disponibles',

  // Hints
  'smsReport.hint.selectQuery': 'Por favor, selecciona condiciones de consulta y haz clic en buscar',
  'smsReport.hint.exportNote': 'La función de exportación generará un reporte en formato Excel',
  'smsReport.hint.timeRangeLimit': 'El rango de tiempo no puede exceder 90 días',

  // Status labels
  'smsReport.status.high': 'Alto',
  'smsReport.status.medium': 'Medio',
  'smsReport.status.low': 'Bajo',

  // Currency units
  'smsReport.currency.usd': 'USD',
  'smsReport.currency.cny': 'CNY',
  'smsReport.currency.php': 'PHP',
  'smsReport.currency.vnd': 'VND',

  // Pagination
  'smsReport.pagination.total': 'Total {{total}} registros'
};
